import { useState } from 'react'
import useFetch from '../hooks/useFetch'
import useSnackbar from '../hooks/useSnackbar'
import { apiWrapper } from './dataHookUtils'

export default () => {
  const fetch = useFetch()
  const { newMessage } = useSnackbar()

  const [isLoading, setIsLoading] = useState()
  const [implementationsCalendar, setImplementationsCalendar] = useState()
  const [eventsCalendar, setEventsCalendar] = useState()

  const fetchImplementations = async (accountId) => {
    return apiWrapper({
      fetch,
      url: `accounts/implementations?accountId=${accountId}`,
      options: {
        method: 'GET'
      }
    });
  }

  const fetchImplementationsCalendar = async () => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: 'accounts/implementationCalendar',
        options: {
          method: 'GET'
        }
      });
      setImplementationsCalendar(result || []);
    } catch (e) {
      console.log(e)
      newMessage({ message: 'Unable to load calendar implementations.', severity: 'failure' });
    } finally {
      setIsLoading(false)
    }
  }

  const fetchEventsCalendar = async () => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: 'accounts/eventsCalendar',
        options: {
          method: 'GET'
        }
      });
      setEventsCalendar(result || []);
    } catch (e) {
      console.log(e)
      newMessage({ message: 'Unable to load calendar events.', severity: 'failure' });
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    fetchImplementations,
    implementationsCalendar,
    fetchImplementationsCalendar,
    eventsCalendar,
    fetchEventsCalendar
  }
}
